<div class="titlu">Arborele genealogic al animalului <b>{{ matricol }}</b></div>

<div [innerHTML]="htmlContent"></div>
<br>
<br>
